module.exports = __webpack_public_path__ + "img/10.full.aa3bf6ec.webp";